import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { DetailPane } from "@/components/layout/detail-panel"
import useCustomToast from "@/hooks/use-custom-toast"
import { requirePermission } from "@/lib/require-permission"
import { previewSearch } from "@/routes/_layout/forecasts_/-lib/search"
import { ForecastForm } from "./-components/form/forecast-form"

export const Route = createFileRoute("/_layout/forecasts/new")({
  staticData: { breadcrumb: "New", detailSidebar: true },
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(queryClient, "forecast:create", "/"),
  component: NewForecastPane,
})

function NewForecastPane(): React.ReactElement {
  const navigate = useNavigate({ from: Route.fullPath })
  const showToast = useCustomToast()
  const close = () => navigate({ to: "/forecasts", search: true })

  return (
    <DetailPane
      title="New forecast"
      heading={<span className="truncate">New forecast</span>}
      onClose={close}
    >
      <ForecastForm
        onCreate={(created) => {
          showToast(`Created ${created.number}`, created.name, "success")
          navigate({
            to: "/forecasts/$forecastId",
            params: { forecastId: created.id },
          })
        }}
        onPreview={(draft) =>
          navigate({ to: "/forecasts/preview", search: previewSearch(draft) })
        }
        onCancel={close}
      />
    </DetailPane>
  )
}
